export const VODAFONE_MOCK_ENABLED = false;

// Postcodes from VodafoneServiceTests.cs and VodafoneRunbookIntegrationTests.cs
// CB5 0ZW  — SOGEA (AVC009_001) + FTTP (AVC009_002)
// CB5 8WX  — FTTP (AVC009_002) + SOGEA (AVC009_001)
// HU12 0SU — SOADSL/Copper (AVC001, access line C001902928074)

const SOGEA_FTTP_RESPONSE = {
  availabilityReference: 'mock-vf-ref-cb5',
  lineDetails: {
    sogea: {
      availabilityDescription: 'SOGEA available',
      ragDescription: 'Green — service can be provided',
      rag: 'Green',
    },
    fttp: {
      availabilityDescription: 'FTTP available',
      ragDescription: 'Green — service can be provided',
      rag: 'Green',
    },
  },
  broadbandGroups: [
    {
      broadbandType: 'SOGEA',
      exchangeTechnology: { network: 'NetworkOnNet' },
      products: [
        {
          productCode: 'AVC009_001',
          productName: 'Vodafone SOGEA 80/20',
          marketLocation: 'Urban',
          isOrderable: true,
          minimumActivationDate: null,
          productOptions: null,
          provisionType: 1,
        },
      ],
    },
    {
      broadbandType: 'FTTP',
      exchangeTechnology: { network: 'NetworkOnNet' },
      products: [
        {
          productCode: 'AVC009_002',
          productName: 'Vodafone FTTP 150/30',
          marketLocation: 'Urban',
          isOrderable: true,
          minimumActivationDate: null,
          productOptions: null,
          provisionType: 1,
          requirements: [{ name: 'Appointment', value: 'Required' }, { name: 'EndUserContact', value: 'Optional' }],
        },
        {
          productCode: 'AVC009_003',
          productName: 'Vodafone FTTP 300/50',
          marketLocation: 'Urban',
          isOrderable: true,
          minimumActivationDate: null,
          productOptions: null,
          provisionType: 1,
          requirements: [{ name: 'Appointment', value: 'Required' }, { name: 'EndUserContact', value: 'Optional' }],
        },
        {
          productCode: 'AVC009_004',
          productName: 'Vodafone FTTP 900/100',
          marketLocation: 'Urban',
          isOrderable: true,
          minimumActivationDate: null,
          productOptions: null,
          provisionType: 1,
          requirements: [{ name: 'Appointment', value: 'Required' }, { name: 'EndUserContact', value: 'Optional' }],
        },
      ],
    },
  ],
  accessLines: [],
  ontDetails: [],
};

const COPPER_RESPONSE = {
  availabilityReference: 'mock-vf-ref-hu12',
  lineDetails: {
    adsl2Plus: {
      availabilityDescription: 'ADSL2+ available',
      ragDescription: 'Green — service can be provided',
      rag: 'Green',
    },
  },
  broadbandGroups: [
    {
      broadbandType: 'Copper',
      exchangeTechnology: { network: 'NetworkOffNet' },
      products: [
        {
          productCode: 'AVC001',
          productName: 'Vodafone ADSL2+ 24/1',
          marketLocation: 'Rural',
          isOrderable: true,
          minimumActivationDate: null,
          productOptions: null,
          provisionType: 2,
        },
      ],
    },
  ],
  accessLines: [{ accessLineId: 'C001902928074' }],
  ontDetails: [],
};

const VODAFONE_MOCK_RESPONSES = {
  'CB50ZW': SOGEA_FTTP_RESPONSE,
  'CB58WX': SOGEA_FTTP_RESPONSE,
  'HU120SU': COPPER_RESPONSE,
};

export function getMockVodafoneResponse(postCode) {
  if (!postCode) return null;
  const key = postCode.replace(/\s+/g, '').toUpperCase();
  return VODAFONE_MOCK_RESPONSES[key] ?? null;
}

// ── Zen mock responses ────────────────────────────────────────────────────────

const ZEN_FTTC_SOGEA_RESPONSE = {
  availabilityReference: 'mock-zen-ref-cb5',
  lineDetails: {
    fttc: {
      availabilityDescription: 'FTTC available',
      ragDescription: 'Green — service can be provided',
      rag: 'Green',
    },
    sogea: {
      availabilityDescription: 'SOGEA available',
      ragDescription: 'Green — service can be provided',
      rag: 'Green',
    },
    lineCharacteristics: {
      btOpenreachPostCode: 'CB5 0ZW',
      btWholesalePostCode: 'CB5 0ZW',
      pcpId: 'CAMB-01',
      lineLength: '800m',
    },
  },
  broadbandGroups: [
    {
      broadbandType: 'FTTC',
      exchangeTechnology: { network: 'NetworkOnNet' },
      products: [
        {
          productCode: 'ZEN_FTTC_0003',
          productName: 'Zen FTTC 40/10',
          marketLocation: 'Urban',
          isOrderable: true,
          minimumActivationDate: null,
          productOptions: null,
          provisionType: 1,
        },
        {
          productCode: 'ZEN_FTTC_0011',
          productName: 'Zen FTTC 80/20',
          marketLocation: 'Urban',
          isOrderable: true,
          minimumActivationDate: null,
          productOptions: null,
          provisionType: 1,
        },
      ],
    },
    {
      broadbandType: 'SOGEA',
      exchangeTechnology: { network: 'NetworkOnNet' },
      products: [
        {
          productCode: 'ZEN_SOGEA_0001',
          productName: 'Zen SOGEA 40/10',
          marketLocation: 'Urban',
          isOrderable: true,
          minimumActivationDate: null,
          productOptions: null,
          provisionType: 1,
        },
        {
          productCode: 'ZEN_SOGEA_0002',
          productName: 'Zen SOGEA 80/20',
          marketLocation: 'Urban',
          isOrderable: true,
          minimumActivationDate: null,
          productOptions: null,
          provisionType: 1,
        },
      ],
    },
  ],
  accessLines: [],
  ontDetails: [],
};

const ZEN_COPPER_RESPONSE = {
  availabilityReference: 'mock-zen-ref-hu12',
  lineDetails: {
    adsl2Plus: {
      availabilityDescription: 'ADSL2+ available',
      ragDescription: 'Green — service can be provided',
      rag: 'Green',
    },
    lineCharacteristics: {
      btOpenreachPostCode: 'HU12 0SU',
      btWholesalePostCode: 'HU12 0SU',
      lineLength: '2500m',
    },
  },
  broadbandGroups: [
    {
      broadbandType: 'Copper',
      exchangeTechnology: { network: 'NetworkOffNet' },
      products: [
        {
          productCode: 'ZEN_ADSL_0001',
          productName: 'Zen ADSL2+ 24/1',
          marketLocation: 'Rural',
          isOrderable: true,
          minimumActivationDate: null,
          productOptions: null,
          provisionType: 1,
        },
      ],
    },
  ],
  accessLines: [],
  ontDetails: [],
};

const ZEN_MOCK_RESPONSES = {
  'CB50ZW': ZEN_FTTC_SOGEA_RESPONSE,
  'CB58WX': ZEN_FTTC_SOGEA_RESPONSE,
  'HU120SU': ZEN_COPPER_RESPONSE,
};

export function getMockZenResponse(postCode) {
  if (!postCode) return null;
  const key = postCode.replace(/\s+/g, '').toUpperCase();
  return ZEN_MOCK_RESPONSES[key] ?? null;
}
